import { Injectable } from '@angular/core';
import { StorageMap } from '@ngx-pwa/local-storage';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageService<T> {
  constructor(private storage: StorageMap) { }

  // Generate a composite key to simulate per-store logic
  private getKey(dbName: string, storeName: string): string {
    return `${dbName}.${storeName}`;
  }

  async getAll(dbName: string, storeName: string): Promise<T[]> {
    const key = this.getKey(dbName, storeName);
    const result = await firstValueFrom(this.storage.get(key) as Observable<T[]>);
    return result || [];
  }

  async putAll(dbName: string, storeName: string, items: T[]): Promise<T[]> {
    const key = this.getKey(dbName, storeName);
    await firstValueFrom(this.storage.set(key, items));
    return items;
  }

  async clearStore(dbName: string, storeName: string): Promise<void> {
    const key = this.getKey(dbName, storeName);
    await firstValueFrom(this.storage.delete(key));
  }
}
